export enum KeyType {
  ENTER = "Enter",
  ESCAPE = "Escape",
  TAB = "Tab",
}
